<div>{{notification.data.localizedTitle[this.currentUser.locale]}}</div>
